export default __webpack_public_path__ + "static/media/Setting.ad73b851.svg";